export default {
    invoices(state)
    {
        return state.invoices
    },
    loading(state)
    {
        return state.loading
    },
    total(state)
    {
        return state.total
    }
}
